<template>
    <div v-if="registration">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">

                <div class="d-none d-lg-block col-lg-4">

                    <user-card :user="learner"></user-card>

                    <overview-nav v-model="selectedPage"
                        :registration="registration"
                        :domains="domains"
                        :simulations="simulations"
                        :ratingOptions="ratingOptions"
                    ></overview-nav>
                </div>

                <div class="col-lg-8">
                    <registration :registration="registration"
                        :learner="learner"
                        :groups="groups"
                        :show-details="false"
                        :nav-to-details="true"
                    ></registration>

                    <user-card class="d-lg-none"
                        :user="learner"
                        :compact="true">
                    </user-card>

                    <overview-nav class="d-lg-none"
                        v-model="selectedPage"
                        :registration="registration"
                        :domains="domains"
                        :simulations="simulations"
                        :ratingOptions="ratingOptions"
                        :compact="true"
                    ></overview-nav>

                    <reviews-card v-show="selectedPage == -1"
                        :title="$t('overview.'+registration.degree.lang+'-global-feedback')"
                        :help="$t('overview.'+registration.degree.lang+'-global-feedback-help')"
                        :lang="registration.degree.lang"
                        :id="-1"
                        :registration="registration"
                        :simulations="simulations"
                    ></reviews-card>

                    <competency-domain v-for="(domain, index) in domains" :key="index"
                        v-show="selectedPage == domain.id"
                        :registration="registration"
                        :simulations="simulations"
                        :competencies="competencies"
                        :position1-competencies="position1Competencies"
                        :position2-competencies="position2Competencies"
                        :ratingOptions="ratingOptions"
                        :domain="domain"
                    ></competency-domain>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserCard from '../auth/components/UserCard'
    import Registration from './learner/Registration';
    import OverviewNav from './learner/overview/Nav'
    import CompetencyDomain from './learner/overview/CompetencyDomain'
    import ReviewsCard from './learner/overview/ReviewsCard';

    export default {

        components: {
            UserCard, Registration, OverviewNav, CompetencyDomain, ReviewsCard
        },

        data() {
            return {
                learner: {},
                groups: null,
                registration: null,
                ratingOptions: null,
                simulations: null,
                competencies: null,
                position1Competencies: null,
                position2Competencies: null,
                domains: null,
                selectedPage: -1,
                acknowledged: false,
                closing: { date: null },
            }
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/registrations/'+to.params.registrationId+'/learners/'+to.params.learnerId)
            .then(resp => {
                next(vm => {
                    vm.registration = resp.data.data
                    vm.learner = resp.data.included.learner
                    vm.groups = resp.data.included.groups
                    vm.ratingOptions = resp.data.included.rating_options
                    vm.simulations = resp.data.included.simulations
                    vm.competencies = resp.data.included.competencies
                    vm.position1Competencies = resp.data.included.position1_competencies
                    vm.position2Competencies = resp.data.included.position2_competencies
                    vm.domains = resp.data.included.competency_domains
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                    vm.acknowledged = resp.data.data.state.meta && resp.data.data.state.meta.acknowledged ? true : false
                    vm.closing = resp.data.data.state.meta && resp.data.data.state.meta.closing ? resp.data.data.state.meta.closing : { date: null }
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },

        computed: {

            breadcrumb() {
                let breadcrumb = []
                if (this.$auth.user.id != this.$route.params.learnerId) {
                    breadcrumb.push({
                        name: this.learner.name,
                        route: '/astral/ui/dashboard/learners/' + this.$route.params.learnerId
                    })
                }
                breadcrumb.push({
                    name: this.registration.degree.name,
                })
                return breadcrumb
            },

            closed() {
                return this.closing.date && new Date(this.closing.date) <= new Date()
            }
        },

        methods: {

            statusChanged(data) {
                this.acknowledged = data.acknowledged ? true : false
                this.closing = data.closing ? data.closing : { date: null }
            },
        }
    }
</script>
